// Sizing got moved up in commmons as the transition to the HR template required multiple comonents being aware of
// the size of the side nav. Specifically the App Header and the SideNav itself
// in pixels
const CLOSED_WIDTH=56;
const EXPANDED_WIDTH=260;
const HEADER_HEIGHT=60;

export { CLOSED_WIDTH, EXPANDED_WIDTH, HEADER_HEIGHT };